import { useState } from 'react';

type Props = {
  url: string | null | undefined;
  name: string;
  isCompact?: boolean;
};

/**
 * Renders a payment icon with consistent sizing and graceful error handling.
 *
 * Returns null when the URL is missing, empty, or when image loading fails.
 */
export default function PaymentIcon({ isCompact = false, name, url }: Props) {
  const [hasError, setHasError] = useState(false);

  // Validate image URL before rendering icon element.
  if ('string' !== typeof url || '' === url.trim() || hasError) {
    return null;
  }

  return (
    <img
      src={url.trim()}
      alt=""
      aria-hidden="true"
      data-payment-name={name}
      style={{ width: `${isCompact ? 60 : 100}px`, height: 'auto', objectFit: 'contain', aspectRatio: '38 / 24' }}
      onError={() => setHasError(true)}
    />
  );
}
